/**
 * Converts number to a currency
 * @param {number|string} value the value to convert
 * @param {string} currency the currency to convert to
 * @returns {string} the converted value
 */
const toCurrency = (value, currency = 'ZAR') =>
  Number(value).toLocaleString('en-ZA', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  });

export default toCurrency;
